// Every Cloudflare deploy removes the previous build's chunks, so a tab left
// open (or restored by the phone) breaks on its next lazily loaded page with
// "Importing a module script failed". Nuxt already turns the next navigation
// into a full page load once it knows a newer build exists, but only checks
// hourly; check whenever the tab comes back into view instead.
export default defineNuxtPlugin((nuxtApp) => {
  let outdated = false;
  nuxtApp.hook('app:manifest:update', () => { outdated = true; });

  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState !== 'visible' || outdated) return;
    try {
      // Compared with the build id baked into this page, not getAppManifest():
      // the old build's manifest is deleted by the deploy too, so fetching it 404s.
      const latest = await $fetch<{ id: string; timestamp: number }>(`/_nuxt/builds/latest.json?${Date.now()}`);
      if (latest.id !== useRuntimeConfig().app.buildId) await nuxtApp.callHook('app:manifest:update', latest);
    } catch {
      // Offline or a missing manifest: the next navigation's chunk error still reloads.
    }
  });
});
